import $ from 'jquery';

$(function() {
  console.log('jQuery ist bereit!');
});